module.exports = __webpack_public_path__ + "img/logo.b60ac715.png";